import type { SupportOptions } from "library/components/SupportLink/SupportLink";
import { dispatchNow } from "store";
import { openChat } from "utilities/HelpCenter/helpCenterSlice";

export type Link = {
  name: string;
  action?: () => void;
  href?: string;
  supportOptions?: SupportOptions;
  to?: string;
  nolang?: boolean;
};

export const LegalLinks: Link[] = [
  {
    name: "Contest Rules",
    supportOptions: { labels: ["weblink-about-pick-ems"] },
  },
  {
    name: "Betting Rules",
    supportOptions: { labels: ["weblink-general-betting-rules"] },
  },
  {
    name: "Racing Rules",
    supportOptions: { labels: ["weblink-racing-rules"] },
  },
  {
    name: "Customer Query, Dispute & Complaints Policy",
    supportOptions: {
      labels: ["weblink-customer-queries-disputes-and-complaints-policy"],
    },
  },
  {
    name: "Promotion Terms",
    supportOptions: { labels: ["weblink-promotional-terms"] },
  },
];

export const AboutLinks: Link[] = [
  {
    name: "FAQ",
    supportOptions: { labels: ["faq button"] },
  },
  {
    name: "Responsible Gambling Policy",
    supportOptions: { labels: ["weblink-responsible-gambling-policy"] },
  },
  {
    name: "Contact Us",
    action: () => dispatchNow(openChat()),
  },
  {
    name: "About Us",
    to: "/account/about",
  },
];
